var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "sui-container",
        { staticClass: "centered", staticStyle: { "padding-top": "52px" } },
        [_c("Header"), _c("account-activation-form")],
        1
      ),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }